module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('vue-headful', {
    attrs: {
      "title": 'SGP - Relatórios da Proposta'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fade-transition",
    attrs: {
      "ng-view": ""
    }
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.show),
      expression: "loading.show"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group required-field"
  }, [_c('label', {
    staticClass: "control-label col-md-3"
  }, [_vm._v("Selecione uma proposta:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.projetos,
      "multiple": false,
      "close-on-select": true,
      "clear-on-select": true,
      "hide-selected": false,
      "preserve-search": true,
      "custom-label": _vm.etiquetaProjeto,
      "placeholder": "Selecione uma proposta",
      "label": "ds_nome",
      "track-by": "id",
      "selectedLabel": "Selecionado",
      "selectLabel": "Aperte ENTER para selecionar",
      "deselectLabel": "Aperte ENTER para remover",
      "name": "projeto",
      "data-vv-as": "projeto"
    },
    on: {
      "select": function($event) {
        return _vm.onSelect($event)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('span', {
          staticClass: "multiselect__tag"
        }, [_c('span', [_vm._v(_vm._s(props.ds_nome))]), _c('span', {
          staticClass: "custom__remove",
          on: {
            "click": function($event) {
              return props.remove(props)
            }
          }
        }, [_vm._v("❌")])])]
      }
    }]),
    model: {
      value: (_vm.projetoSelecionado),
      callback: function($$v) {
        _vm.projetoSelecionado = $$v
      },
      expression: "projetoSelecionado"
    }
  })], 1)]), _vm._v(" "), (!_vm._.isEmpty(_vm.projetoSelecionado)) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-3"
  }, [_vm._v("Entidade:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_vm._v("\n                        " + _vm._s(_vm.projetoSelecionado.ds_cnpj) + " - " + _vm._s(_vm.projetoSelecionado.NomeEntidade) + "\n                      ")])]), _vm._v(" "), (!_vm._.isEmpty(_vm.projetoSelecionado.ds_numero_edital)) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-3"
  }, [_vm._v("Edital:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_vm._v("\n                          " + _vm._s(_vm.projetoSelecionado.ds_numero_edital) + "\n                        ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-3"
  }, [_vm._v("Fase:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_vm._v("\n                        " + _vm._s(_vm.projetoSelecionado.ds_fase) + "\n                      ")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 col-md-offset-3 box-footer d-flex flex-wrap-nowrap"
  }, [(_vm._.has(_vm.projetoSelecionado, 'id')) ? _c('div', [_c('router-link', {
    staticClass: "btn btn-primary btn-sm btn-flat",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "to": {
        name: 'imprimir-proposta',
        params: {
          id: _vm.projetoSelecionado.id
        }
      },
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Versão para impressão da Proposta\n                    ")]), _vm._v(" "), (_vm._.includes(['ANALISE', 'DEFERIMENTO', 'FORMALIZACAO', 'APROVACAO_PROJETO', 'APROVADO'], _vm.projetoSelecionado.ds_fase)) ? _c('span', [_c('router-link', {
    staticClass: "btn btn-primary btn-sm btn-flat",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "to": {
        name: 'relatorio-fep',
        params: {
          id: _vm.projetoSelecionado.id
        }
      },
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  FEP\n                      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-sm btn-flat",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "to": {
        name: 'relatorio-rating',
        params: {
          id: _vm.projetoSelecionado.id
        },
        query: {
          entidade: _vm.projetoSelecionado.idEntidade
        }
      },
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v("  Rating da Entidade\n                      ")]), _vm._v(" "), (_vm.projetoSelecionado['relatorio_analise'] == null) ? _c('span', [_c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    staticClass: "btn btn-primary btn-sm btn-flat",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "disabled": _vm.projetoSelecionado['relatorio_analise'] == null,
      "target": "_blank",
      "title": _vm.titulo
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v("  Relatório de Análise\n                        ")])]) : _c('span', [_c('router-link', {
    staticClass: "btn btn-primary btn-sm btn-flat",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "to": {
        name: 'visualiza-relatorio-analise',
        params: {
          id: _vm.projetoSelecionado.id,
          projeto: _vm.projetoSelecionado.ds_codigo_projeto_erp
        }
      },
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v("  Relatório de Análise\n                        ")])], 1), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-sm btn-flat",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "to": {
        name: 'plano-trabalho',
        params: {
          id: _vm.projetoSelecionado.id
        }
      },
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v("  Plano de Trabalho\n                      ")])], 1) : _vm._e(), _vm._v(" "), (_vm._.includes(['ANALISE'], _vm.projetoSelecionado.ds_fase) && _vm.projetoSelecionado.ds_codigo_projeto_erp !== '00000') ? _c('span', [_c('button', {
    staticClass: "btn btn-primary btn-sm btn-flat",
    staticStyle: {
      "text-decoration": "none"
    },
    on: {
      "click": function($event) {
        _vm.mostrarBriefing = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v("  Relatório de Briefing\n                      ")])]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), (_vm.mostrarBriefing) ? _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-card', {
    staticClass: "mb-3",
    attrs: {
      "title": "Dados que devem constar no Briefing"
    }
  }, [_c('div', {
    staticClass: "checkbox-block"
  }, [_c('b-form-checkbox-group', {
    staticClass: "mb-3",
    attrs: {
      "stacked": ""
    },
    model: {
      value: (_vm.selecionadosBriefing),
      callback: function($$v) {
        _vm.selecionadosBriefing = $$v
      },
      expression: "selecionadosBriefing"
    }
  }, _vm._l((_vm.dadosBriefing), function(item) {
    return _c('b-form-checkbox', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_c('span', {
      staticStyle: {
        "margin-left": "8px"
      }
    }, [_vm._v(_vm._s(item.nome))])])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end mt-3"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm btn-flat",
    class: {
      'btn-opaco': _vm.botaoClicado
    },
    attrs: {
      "disabled": _vm.botaoClicado
    },
    on: {
      "click": _vm.gerarBriefing
    }
  }, [_vm._v("  \n                          Gerar arquivo de Briefing  \n                        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-sm btn-flat ml-2",
    on: {
      "click": _vm.cancelarBriefing
    }
  }, [_vm._v("  \n                          Cancelar  \n                        ")])])])], 1)]) : _vm._e()])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Relatórios")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Relatórios da Proposta")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0c909fcc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/relatorios/ImpressaoRel.vue
// module id = 1860
// module chunks = 1